import React, { useEffect, useRef, useState } from 'react';
import * as ReactDOM from 'react-dom';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import { renderToStaticMarkup } from 'react-dom/server';

import ContentEditable from 'react-contenteditable';

import IfBlock from './Blocks/If';
import VariableBlock from './Blocks/Variable';
import ConstantBlock from './Blocks/Constant';
import ArithmeticBlock from './Blocks/ArithmeticBlock';
import Block from './Blocks/Block';
import BuilderHeader from './BuilderHeader';
import BuilderSidePanel from './BuilderSidePanel';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import * as classes from './FormulaBuilder.module.css';
import ControlBlock from './Blocks/ControlBlock';
import StatementBlock from './Blocks/StatementBlock';
import ListBlock from './Blocks/ListBlock';
import ListModal from './ListModal';

const Else = id => {
    return (
        <React.Fragment>
            <div id={`${id}-else-block-start`} data-allow-insert={false} className={classes.BlockTitleAlt}>
                ELSE
            </div>
            <div id="else-block-body" className={classes.InLineBlock}>
                <React.Fragment id="if-block">&nbsp;</React.Fragment>
            </div>
            <div id="else-block-end" />
        </React.Fragment>
    );
};

const ElseIf = id => {
    return (
        <React.Fragment>
            <div id={'elseIf-block-start'} data-allow-insert={false} className={classes.BlockTitleAlt}>
                ELSE IF
            </div>
            <div id="elseIf-block-body" className={classes.InLineBlock}>
                <React.Fragment id="if-block">&nbsp;</React.Fragment>
            </div>
            <div id="if-block-end" data-allow-insert={false} className={classes.BlockTitleAlt}>
                THEN
            </div>
            <div id="if-block-then" className={classes.InLineBlock}>
                <React.Fragment id="if-block">&nbsp;</React.Fragment>
            </div>
            <div id="if-block-then-end" />
        </React.Fragment>
    );
};

const FormulaBuilder = ({
    sensorTypes,
    setFormula,
    ...props
}) => {
    const innerEditor = useRef(null);
    const text = useRef('');
    const [functionValues, setFunctionValues] = useState([]);
    const [variableValues, setVariableValues] = useState([]);
    const [controlValues, setControlValues] = useState([]);
    const [statementValues, setStatementValues] = useState([]);
    const [availableSensorTypes, setAvailableSensorTypes] = useState([]);
    const [listModalOpen, setListModalOpen] = useState(false);

    const [selectedOptions, setSelectionOptions] = useState([]);
    const [selectedDiv, setSelectedDiv] = useState('');
    const [selectedType, setSelectedType] = useState('');

    useEffect(() => {
        if (!isEmpty(sensorTypes)) {
            setAvailableSensorTypes(sensorTypes[0].items);
        }
    }, [sensorTypes]);

    useEffect(() => {
        text.current = '';

        const trackEnter = e => {
            if (!(e.target && e.target.className && e.target.className.includes('formula-textbox'))) {
                e.preventDefault();
            }
        };

        if (document.getElementById('formula-editor')) {
            document.getElementById('formula-editor').addEventListener('keydown', trackEnter);
        }

        document.querySelector('.ccb-editor-container').addEventListener('click', handleClick);


        return () => {
            if (document.getElementById('formula-editor')) {
                document.getElementById('formula-editor').removeEventListener('keydown', trackEnter);
            }

            if (document.querySelector('.ccb-editor-container')) {
                document.querySelector('.ccb-editor-container').removeEventListener('click', handleClick);
            }
        };
    }, []);

    const handleClick = (e) => {
        syncModelVal();

        if (e.target.id.includes('delete')) {
            const divId = e.target.id.split('-')[0];
            if (e.target.className.includes('ArithmeticBlock')) {
                let updatedFunctionValues = functionValues;
                updatedFunctionValues = updatedFunctionValues.filter(item => item.id !== divId);
                setFunctionValues(updatedFunctionValues);
            } else if (e.target.className.includes('Variable_Select')) {
                let updatedVariableValues = variableValues;
                updatedVariableValues = updatedVariableValues.filter(item => item.id !== divId);
                setVariableValues(updatedVariableValues);
            }

            const element = document.querySelector(`[id*="${divId}"]`);
            element.remove();
        } else if (e.target.id.includes('options')) {
            const divId = e.target.id.split('-')[0];
            const element = document.querySelector(`[id*="${divId}"]`);
            const type = element.getAttribute('data-type');

            const list = e.target.parentNode.childNodes[0].childNodes;
            const filteredList = Array.from(list).filter(item => item.id !== '');

            setSelectionOptions(filteredList);
            setSelectedDiv(divId);
            setSelectedType(type);
            setListModalOpen(true);
        } else if (e.target.innerText === 'ELSE') {
            const divId = e.target.id.split('-')[0];
            document.getElementById(`${divId}-if-body`).insertAdjacentHTML('beforeend', renderToStaticMarkup(<Else id={divId} />));
        } else if (e.target.innerText === 'ELSE IF') {
            const divId = e.target.id.split('-')[0];
            document.getElementById(`${divId}-if-body`).insertAdjacentHTML('beforeend', renderToStaticMarkup(<ElseIf id={divId} />));
        } else if (e.target.className.includes('ArithmeticBlock')) {
            const updatedFunctionValues = functionValues;

            const element = e.path[3];
            const selectedId = element.getAttribute('data-id');
            if (selectedId) {
                const index = functionValues.findIndex(item => item.id === selectedId);
                if (index >= 0) {
                    updatedFunctionValues[index] = { id: selectedId, value: e.target.value };
                } else {
                    updatedFunctionValues.push({ id: selectedId, value: e.target.value });
                }
            }
            setFunctionValues(updatedFunctionValues);
        } else if (e.target.className.includes('StatementBlock')) {
            const updatedStatementValues = statementValues;

            const element = e.path[3];
            const selectedId = element.getAttribute('data-id');
            if (selectedId) {
                const index = statementValues.findIndex(item => item.id === selectedId);
                if (index >= 0) {
                    updatedStatementValues[index] = { id: selectedId, value: e.target.value };
                } else {
                    updatedStatementValues.push({ id: selectedId, value: e.target.value });
                }
            }
            setStatementValues(updatedStatementValues);
        } else if (e.target.className.includes('Variable_Select')) {
            const updatedVariableValues = variableValues;

            const itemId = e.target.selectedOptions[0].getAttribute('data-itemid');
            const element = e.path[0];
            const selectedId = element.getAttribute('data-id');

            if (selectedId) {
                const index = variableValues.findIndex(item => item.id === selectedId);
                if (index >= 0) {
                    updatedVariableValues[index] = { id: selectedId, value: e.target.value, itemId };
                } else {
                    updatedVariableValues.push({ id: selectedId, value: e.target.value, itemId });
                }
            }
            setVariableValues(updatedVariableValues);
        }
        syncModelVal();
    };

    const handleChange = evt => {
        let formula = parseHtml(evt.target.value);
        formula = 'return ' + formula;
        setFormula(formula);
    };

    const parseHtml = html => {
        let formula = '';
        let htmlObject = document.createElement('div');
        htmlObject.innerHTML = html;
        
        let divs = htmlObject.getElementsByTagName('div');
        const filteredDivs = Array.from(divs).filter(div => div.id !== '');

        filteredDivs.forEach(item => {
            if (item.id.includes('if-block-start')) {
                formula = formula + 'if ';
            } else if (item.id.includes('if-block-body')) {
                formula = formula + '(';
            } else if (item.id.includes('if-block-end')) {
                formula = formula + ')';
            } else if (item.id.includes('variable')) {
                const selectedId = item.getAttribute('data-id');
                const variableValue = variableValues.find(item => item.id === selectedId);

                if (variableValue) {
                    formula = formula + variableValue.value;
                }
            } else if (item.id === 'if-block-then') {
                formula = formula + ' then (';
            } else if (item.id === 'if-block-then-end') {
                formula = formula + ')';
            } else if (item.id.includes('arithmetic-block')) {
                const selectedId = item.getAttribute('data-id');
                const arithmeticValue = functionValues.find(item => item.id === selectedId);

                if (arithmeticValue) {
                    formula = formula + arithmeticValue.value;
                }
            } else if (item.id.includes('statement-block')) {
                const selectedId = item.getAttribute('data-id');
                const statementValue = statementValues.find(item => item.id === selectedId);

                if (statementValue) {
                    if (statementValue.value === 'And') {
                        formula = formula + ' && ';
                    } else if (statementValue.value === 'Or') {
                        formula = formula + ' || ';
                    } else if (statementValue.value === 'Not') {
                        formula = formula + ' != ';
                    } else if (statementValue.value === 'True' || statementValue.value === 'False' || statementValue.value === 'Null') {
                        formula = formula + statementValue.value.toLowerCase();
                    }
                }
            } else if (item.id.includes('block-constant')) {
                const selectedId = item.getAttribute('data-id');
                const value = document.getElementById(`${selectedId}-input-value`);
                let constant = value.getAttribute('defaultvalue');

                if (constant) {
                    formula = formula + constant;
                } else {
                    formula = formula + 'null';

                }
            } else if (item.id.includes('control-block')) {
                const selectedId = item.getAttribute('data-id');
                const controlValue = controlValues.find(item => item.id === selectedId);

                if (controlValue) {
                    formula = formula + controlValue.value;
                }
            } else if (item.id.includes('else-block-start')) {
                formula = formula + ' else ';
            } else if (item.id.includes('else-block-body')) {
                formula = formula + '(';
            } else if (item.id.includes('else-block-end')) {
                formula = formula + ')';
            } else if (item.id.includes('elseIf-block-start')) {
                formula = formula + ' else if ';
            } else if (item.id.includes('elseIf-block-body')) {
                formula = formula + '(';
            } else if (item.id.includes('math-block')) {
                const type = item.getAttribute('data-type');

                if (type === 'Square Root') {
                    formula = formula + 'Math.sqrt';
                } else if (type === 'Round') {
                    formula = formula + 'Math.round';
                } else if (type === 'Round Up') {
                    formula = formula + 'Math.ceil';
                } else if (type === 'Round Down') {
                    formula = formula + 'Math.floor';
                } else if (type === 'Absolute') {
                    formula = formula + 'Math.abs';
                } else if (type === 'Log 10') {
                    formula = formula + 'Math.log';
                } else if (type === 'e^x') {
                    formula = formula + 'Math.exp';
                } else if (type === '10^x') {
                    formula = formula + 'Math.pow';
                } else if (type === 'Is Even') {
                    formula = formula + '(';
                } else if (type === 'Is Odd') {
                    formula = formula + '(';
                } else if (type === 'Is Prime') {
                    formula = formula + 'mathIsPrime';
                } else if (type === 'Is Whole') {
                    formula = formula + '(';
                } else if (type === 'Is Positive') {
                    formula = formula + '(';
                } else if (type === 'Is Negative') {
                    formula = formula + '(';
                }
            } else if (item.id === 'math-start') {
                const type = item.getAttribute('data-type');

                if (type === '10^x') {
                    formula = formula + '(10, ';
                } else if (type === 'Is Even' || type === 'Is Odd' || type === 'Is Whole' || type === 'Is Positive' || type === 'Is Negative') {
                    return;
                } else {
                    formula = formula + '(';
                }
            } else if (item.id === 'math-end') {
                const type = item.getAttribute('data-type');

                if (type === 'Log 10') {
                    formula = formula + ') / Math.log(10)';
                } else if (type === 'Is Even') {
                    formula = formula + ' % 2 == 0)';
                } else if (type === 'Is Odd') {
                    formula = formula + ' % 2 == 1)';
                } else if (type === 'Is Whole') {
                    formula = formula + ' % 1 == 0)';
                } else if (type === 'Is Positive') {
                    formula = formula + ' > 0)';
                } else if (type === 'Is Negative') {
                    formula = formula + ' < 0)';
                } else {
                    formula = formula + ')';
                }
            } else if (item.id.includes('list-block')) {
                const type = item.getAttribute('data-type');

                if (type === 'Max') {
                    formula = formula + 'Math.max.apply(null, [';
                } else if (type === 'Min') {
                    formula = formula + 'Math.min.apply(null, [';
                } else if (type === 'Sum') {
                    formula = formula + '[';
                } else if (type === 'Average') {
                    formula = formula + 'mathMean(';
                } else if (type === 'Median') {
                    formula = formula + 'mathMedian(';
                } else if (type === 'Modes') {
                    formula = formula + 'mathModes(';
                } else if (type === 'Standard Deviation') {
                    formula = formula + 'mathStandardDeviation(';
                } else if (type === 'Random Item') {
                    formula = formula + 'mathRandomList(';
                }

            } else if (item.id === 'list-start') {
                formula = formula + '';
            } else if (item.id === 'list-end') {
                const type = item.getAttribute('data-type');

                if (type === 'Sum') {
                    formula = formula + '].reduce(function(x, y) {return x + y;})';
                } else if (type === 'Average' || type === 'Median' || type === 'Modes' || type === 'Standard Deviation' || type === 'Random Item') {
                    formula = formula + ')';
                } else {
                    formula = formula + '])';
                }
            } else if (item.id === 'comma') {
                formula = formula + ',';
            }
        });
        return formula;
    };

    //const placeCaretAtEnd = (el) => {
    //    // contentEditable
    //    let range = document.createRange();
    //    range.selectNodeContents(el);
    //    range.collapse(false);
    //    let selection = window.getSelection();
    //    selection.removeAllRanges();
    //    selection.addRange(range);
    //};

    const handleCloseModal = () => {
        setSelectionOptions([]);
        setListModalOpen(false);
    };

    const handleSaveList = (list, type) => {
        syncModelVal();


        const element = document.querySelector(`[id*="${selectedDiv}"]`);
        let key = getRandom();
        const val = getListBlock(type, key, list.length, list);

        var wrapper = document.createElement('div');
        wrapper.innerHTML = val;
        var div = wrapper.firstChild;

        element.replaceWith(div);

        syncModelVal();
        setSelectionOptions([]);
        setListModalOpen(false);
    };


    const pasteHtmlAtCaret = (html) => {
        var sel, range;
        if (window.getSelection) {
            sel = window.getSelection();

            const element = window.getSelection().focusNode.parentElement;
            const allowInsert = element.getAttribute('data-allow-insert');

            if (allowInsert !== null && (!allowInsert || allowInsert === 'false')) return;

            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                var el = document.createElement('div');
                el.innerHTML = html;
                var frag = document.createDocumentFragment(), node, lastNode;
                while ((node = el.firstChild)) {
                    lastNode = frag.appendChild(node);
                }
                range.insertNode(frag);

                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        } else if (document.selection && document.selection.type !== 'Control') {
            document.selection.createRange().pasteHTML(html);
        }

    };

    const connectorsClicked = (e) => {
        const trackEnter = (e) => {
            let id = e.target.id;
            document.getElementById(id).setAttribute('defaultValue', e.target.value);
        };

        let selection = window.getSelection();
        let isInsideFormula = false;

        const isInsideFormulaEditor = (node) => {
            if (!node.parentNode) {
                isInsideFormula = false;
                return;
            }

            if (node.id === 'formula-editor' || node.parentNode.id === 'formula-editor') {
                isInsideFormula = true;
                return;
            } else {
                isInsideFormulaEditor(node.parentNode);
            }
        };

        if (selection.focusNode && selection.focusNode.parentNode) {
            if (selection.focusNode.id !== 'formula-editor' || (selection.focusNode.parentNode && selection.focusNode.parentNode.id !== 'formula-editor')) {
                isInsideFormulaEditor(selection.focusNode);
                if (!isInsideFormula) {
                    return;
                    //move carat to end
                }
            }
        } else {
            return;
            //Move carat to end
        }


        let key = getRandom();

        let val = e.target.textContent || e.target.getAttribute('data-key');
        if (val === 'VARIABLE') {
            val = getVariableBlock(key);
        }
        else if (
            val === 'Round Up' || val === 'Round Down' || val === 'Absolute' ||
            val === 'Square Root' || val === 'Round' ||
            val === 'Is Even' ||
            val === 'Is Odd' || val === 'Is Prime' || val === 'Is Whole' ||
            val === 'Is Positive' || val === 'Is Negative' || val === 'Log 10' ||
            val === 'e^x' || val === '10^x'
        ) {
            val = getBlock(val, key);
        }
        else if (val === 'And' || val === 'Or' || val === 'Not' || val === 'True' || val === 'False' || val === 'Null') {
            val = getStatementBlock(val, key);
        }
        else if (val === '+' || val === '-' || val === '*' || val === '/' || val === '%' || val === '^') {
            val = getArithmeticBlock(val, key);
        }
        else if (val === '=' || val === '!=' || val === '<' || val === '<=' || val === '>' || val === '>=') {
            val = getControlBlock(val, key);
        }
        else if (
            val === 'Sum' || val === 'Min' || val === 'Max' ||
            val === 'Average' || val === 'Median' || val === 'Modes' ||
            val === 'Random Item' || val === 'Standard Deviation') {
            val = getListBlock(val, key, 3);
        }
        else if (val === 'CONSTANT') {
            val = getConstantBlock(key);

            //val = getVariableToken(key);
            setTimeout(() => {
                let textbx = document.getElementById(`${key}-block-constant`);
                if (textbx) textbx.focus();
                textbx.addEventListener('input', trackEnter);
            }, 300);
        }
        else if (val === 'If') {
            val = getIfBlock(key);
        }

        pasteHtmlAtCaret(val);
        syncModelVal();
    };

    const syncModelVal = () => {
        if (innerEditor && innerEditor.current) {
            text.current = innerEditor.current.innerHTML;
        }
    };

    const getRandom = () => {
        return Math.round(1 + Math.random() * 999);
    };

    const getIfBlock = (key) => {
        const span = document.createElement('span');
        ReactDOM.render(<IfBlock id={key} />, span);

        return `${span.innerHTML}`;
    };

    const getVariableBlock = (key) => {

        const span = document.createElement('span');

        const element = window.getSelection().focusNode.parentElement;
        const parentId = element.getAttribute('data-parentId');

        const updatedVariableValues = [...variableValues];
        updatedVariableValues.push({ id: key.toString(), value: null });
        setVariableValues(updatedVariableValues);

        ReactDOM.render(<VariableBlock sensorTypes={availableSensorTypes} parentId={parentId} id={key} />, span);

        return `${span.innerHTML}`;
    };

    const getBlock = (type, key) => {
        const span = document.createElement('span');
        ReactDOM.render(<Block type={type} id={key} />, span);

        return `${span.innerHTML}`;
    };

    const getConstantBlock = key => {
        const span = document.createElement('span');

        ReactDOM.render(<ConstantBlock id={key} />, span);

        return `${span.innerHTML}`;
    };

    const getArithmeticBlock = (val, key) => {
        const span = document.createElement('span');

        const element = window.getSelection().focusNode.parentElement;
        const parentId = element.getAttribute('data-parentId');

        const updatedFunctionValues = [...functionValues];
        updatedFunctionValues.push({ id: key.toString(), value: val });
        setFunctionValues(updatedFunctionValues);


        ReactDOM.render(<ArithmeticBlock parentId={parentId} value={val} id={key} />, span);
        return `${span.innerHTML}`;
    };

    const getControlBlock = (val, key) => {
        const span = document.createElement('span');

        const element = window.getSelection().focusNode.parentElement;
        const parentId = element.getAttribute('data-parentId');

        const updatedControlValues = [...controlValues];
        updatedControlValues.push({ id: key.toString(), value: val });
        setControlValues(updatedControlValues);

        ReactDOM.render(<ControlBlock parentId={parentId} value={val} id={key} />, span);
        return `${span.innerHTML}`;
    };

    const getStatementBlock = (val, key) => {
        const span = document.createElement('span');

        const element = window.getSelection().focusNode.parentElement;
        const parentId = element.getAttribute('data-parentId');

        const updatedStatementValues = [...statementValues];
        updatedStatementValues.push({ id: key.toString(), value: val });
        setStatementValues(updatedStatementValues);


        ReactDOM.render(<StatementBlock parentId={parentId} value={val} id={key} />, span);
        return `${span.innerHTML}`;
    };

    const getListBlock = (type, key, num, list) => {
        const span = document.createElement('span');
        ReactDOM.render(
            <ListBlock
                type={type}
                id={key}
                number={num}
                list={list}
            />,
            span);

        return `${span.innerHTML}`;
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <div className={classes.EditorColContainer} style={props.mode === 'formula' ? { overflowY: 'auto' } : { overflowY: 'auto' }}>
            <BuilderSidePanel />
            <div className={`${classes.Editor} ${classes.Formulabuttons}`}>
                <BuilderHeader
                    connectorsClicked={connectorsClicked}
                />
                <div className="ccb-editor-container" style={{ height: '100%', marginLeft: 15, overflow: 'auto' }}>
                    <ContentEditable
                        id="formula-editor"
                        disabled={false}
                        innerRef={innerEditor} style={!isEmpty(innerEditor.current) ? { height: 'fit-content', minHeight: '10rem', fontSize: 15, display: 'flex', alignItems: 'center' } : { height: '100%', fontSize: 15, display: 'flex', alignItems: 'center' }}
                        html={text.current}
                        onChange={handleChange}
                    />
                </div>
                <div className={classes.BottomPanel}>
                    <FormControlLabel                     
                        control={
                            <Checkbox
                                style={{ transform: 'scale(1.5)', color: 'black' }}
                            />
                        }
                        label={<Typography className={classes.Label}>Rule Aggregate</Typography>}
                    />
                    <FormControl
                        style={{ marginLeft: '0.8rem', marginRight: '1.5rem' }}
                        variant="outlined"
                        size="small"
                        className={classes.InputWrapper}
                    >
                        <InputLabel
                            htmlFor="templateName"
                            classes={{
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }}
                        >
                            Type
                        </InputLabel>
                        <Select
                            value={''}
                            id="type"
                            MenuProps={MenuProps}
                            name="type"
                            classes={{
                                root: classes.input
                            }}
                        >
                            <MenuItem
                                key={0}
                                value={0}
                            >
                                Template A
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl
                        size="small"
                        className={classes.userInputWrapper}
                        style={{ width: 150, marginLeft: 15 }}
                    >
                        <TextField
                            size="small"
                            variant="outlined"
                            id="name"
                            name="name"
                            type="text"
                            value={''}
                            label={'Duration'}
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            inputProps={{ maxLength: 250 }}
                            InputProps={{
                                classes: {
                                    error:     classes.cssErrorUnderline,
                                    underline: classes.cssUnderline,
                                    root:      classes.input
                                }
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                        />
                    </FormControl>
                </div>
            </div>
            {
                listModalOpen ?
                    <ListModal
                        open={listModalOpen}
                        close={handleCloseModal}
                        list={selectedOptions}
                        save={handleSaveList}
                        parseHtml={parseHtml}
                        selectedType={selectedType}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        sensorTypes: state.sensorTypes.data
    };
};

export default connect(mapStateToProps, null)(FormulaBuilder);
